module.exports = __webpack_public_path__ + "static/media/A4.6109ba57.jpg";